import React from "react";
import { Link, useLocation } from "react-router-dom";
import { FiTwitter, FiInstagram, FiFacebook, FiLinkedin } from "react-icons/fi";
import Logo from "assets/img/logo.png"

const Footer = () => {
  const location = useLocation();

  const scrollToSection = (sectionId) => {
    if (location.pathname === "/") {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    } else {
      window.location.href = `/#${sectionId}`;
    }
  };

  return (
    <footer className="via-violet-50/30 bg-gradient-to-br from-white/80 to-purple-50/20 backdrop-blur-[2px]">
      <div className="mx-auto max-w-5xl px-4 py-12">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-3">
          {/* Brand Section */}
          <div className="flex justify-center">
            <div className="col-span-1">
              <Link
                to="/"
                className="inline-flex items-center space-x-3 transition-transform duration-300 hover:scale-105"
              >
                <img src={Logo} alt="Logo" className="h-10 w-auto" />
                <span className="ml-2 text-xl font-bold text-gray-900">
                  Riplestack
                </span>
              </Link>
              <p className="mt-4 text-sm leading-relaxed text-gray-600">
                Simplify your social media management with powerful tools and
                analytics.
              </p>
            </div>
          </div>

          {/* Product Links */}
          <div className="flex justify-start md:justify-center">
            <div className="col-span-1 flex flex-col">
              <h3 className="mb-4 text-center text-start text-lg font-semibold text-gray-800">
                Product
              </h3>
              <ul className="flex flex-col space-y-3">
                <li>
                  <button
                    onClick={() => scrollToSection("features")}
                    className="text-left text-gray-600 transition-colors duration-300 hover:text-purple-700"
                  >
                    Features
                  </button>
                </li>
                <li>
                  <button
                    onClick={() => scrollToSection("pricing")}
                    className="text-left text-gray-600 transition-colors duration-300 hover:text-purple-700"
                  >
                    Pricing
                  </button>
                </li>
                <li>
                  <button
                    onClick={() => scrollToSection("how-it-works")}
                    className="text-left text-gray-600 transition-colors duration-300 hover:text-purple-700"
                  >
                    How it Works
                  </button>
                </li>
              </ul>
            </div>
          </div>

          {/* Social Links */}
          <div className="col-span-1">
            <h3 className="mb-4 text-start text-lg font-semibold text-gray-800 md:text-center">
              Connect
            </h3>
            <div className="justify-startspace-x-5 flex md:justify-center">
              <a
                href="#"
                className="rounded-full p-2 text-gray-600 transition-all duration-300 hover:bg-white/80 hover:text-purple-700 hover:shadow-lg"
                aria-label="Twitter"
              >
                <FiTwitter size={20} />
              </a>
              <a
                href="#"
                className="rounded-full p-2 text-gray-600 transition-all duration-300 hover:bg-white/80 hover:text-purple-700 hover:shadow-lg"
                aria-label="Instagram"
              >
                <FiInstagram size={20} />
              </a>
              <a
                href="#"
                className="rounded-full p-2 text-gray-600 transition-all duration-300 hover:bg-white/80 hover:text-purple-700 hover:shadow-lg"
                aria-label="Facebook"
              >
                <FiFacebook size={20} />
              </a>
              <a
                href="#"
                className="rounded-full p-2 text-gray-600 transition-all duration-300 hover:bg-white/80 hover:text-purple-700 hover:shadow-lg"
                aria-label="LinkedIn"
              >
                <FiLinkedin size={20} />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-10 flex flex-col items-center justify-between border-t border-purple-100 pt-8 md:flex-row">
          <p className="text-sm text-gray-600">
            © {new Date().getFullYear()} SocialPro. All rights reserved.
          </p>
          <div className="mt-4 flex space-x-6 md:mt-0">
            <Link
              to="/privacy"
              className="text-sm text-gray-600 transition-colors duration-300 hover:text-purple-700"
            >
              Privacy Policy
            </Link>
            <Link
              to="/terms"
              className="text-sm text-gray-600 transition-colors duration-300 hover:text-purple-700"
            >
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
